module.exports = __webpack_public_path__ + "static/media/slider_2_master_user_es.6ed02f45.svg";